export default function VideoBlock() {
  const playBtns = document.querySelectorAll('.global-video-block__other-video .video-btn-wrap');
  if (playBtns) {
    playBtns.forEach((btn, i) => {
      const video = btn.previousElementSibling;
      video.addEventListener('playing', () => btn.dataset.playing = true);
      video.addEventListener('pause', () => btn.dataset.playing = false);
      video.addEventListener('ended', () => {btn.dataset.playing = false; video.load();});
      btn.addEventListener('click', () => {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      })
    })
  }
}

